<template>
  <div>
    <div class="scrollCardAngebotPreise-1">
      <div class="container">
        <div class="scrollContentTitle">
          <h6 class="title title-up text-center navHeadline">Angebot & Preise</h6>
          <h4 class="text-center title navHeadlineText"></h4>
        </div>

        <div class="row justify-content-md-center">
          <p class="text text-center">

          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "AngebotPreise"
    }
</script>

<style scoped>

</style>